import { format, parseJSON } from "date-fns";
type dateTimeFormatString = "EEE, dd/MM/yy" | "yyyy-MM-dd" | "EEE, dd/MM/yy hh:mm aaa" | "dd/MM/yy hh:mm aaa";

export type dateTimeFormat = { format: dateTimeFormatString };
export const longDateFormat: dateTimeFormat = { format: "EEE, dd/MM/yy" };
export const dateStringFormat: dateTimeFormat = { format: "yyyy-MM-dd" };
export const longDateTimeFormat: dateTimeFormat = { format: "EEE, dd/MM/yy hh:mm aaa" };
export const shortDateTimeFormat: dateTimeFormat = { format: "dd/MM/yy hh:mm aaa" };

export type dateDiff = {
	years?: number;
	days?: number;
	hours?: number;
	minutes?: number;
	seconds?: number;
};

//converts datestring of format "2012-05-15" to javascript date format
export const dateStringToDate = (dateString: string): Date => {
	const year: number = +dateString.substring(0, 4);
	const month: number = +dateString.substring(5, 7);
	const day: number = +dateString.substring(8, 10);
	return new Date(year, month - 1, day);
};

export const dateStringToDisplayDate = (dateString: string, dateFormat = "EEE, dd/MMM/yy"): string => {
	const date = dateStringToDate(dateString);
	return format(date, dateFormat);
};

export function formatDate(date: Date, dateTimeFormat: dateTimeFormat): string {
	const parsedDate = parseJSON(JSON.stringify(date));
	return format(parsedDate, dateTimeFormat.format);
}

//https://bearnithi.com/2019/11/10/how-to-calculate-the-time-difference-days-hours-minutes-between-two-dates-in-javascript/#:~:text=Calculate%20Hours%20Difference%20between%20Two%20Dates%20in%20JavaScript,diffInMilliSeconds%20-%3D%20hours%20%2A%203600%3B%20console.log%28%27calculated%20hours%27%2C%20hours%29%3B
export function getDateDifference(endDate: Date, startDate: Date): dateDiff {
	let diffInMilliseconds = Math.abs(endDate.getTime() - startDate.getTime()) / 1000; // Diff in milliseconds

	// Get days difference
	const days = Math.floor(diffInMilliseconds / 86400);
	diffInMilliseconds -= days * 86400;

	// Get hours difference
	const hours = Math.floor(diffInMilliseconds / 3600) % 24;
	diffInMilliseconds -= hours * 3600;

	// Get minutes difference
	const minutes = Math.floor(diffInMilliseconds / 60) % 60;
	diffInMilliseconds -= minutes * 60;

	// Get seconds difference
	const seconds = Math.floor(diffInMilliseconds);

	return {
		days: days,
		hours: hours,
		minutes: minutes,
		seconds: seconds,
	};
}
